import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import 'intersection-observer'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import AppStateMixin from './mixins/appstate'
import LoadingState from './components/LoadingState.vue'
import AppDailog from './components/AppDailog.vue'
import AppHangDailog from './components/AppHangDailog.vue'
import SvgIcon from './components/SvgIcon.vue'

import FootballMatchMini from './components/football/FootballMatchMini.vue'
import FootballMatchTimeline from './components/football/FootballMatchTimeline.vue'
import FootballMatchTeam from './components/football/FootballMatchTeam.vue'
import FootballMatchStats from './components/football/FootballMatchStats.vue'

import KabaddiSeasonMenu from './components/kabaddi/SeasonMenu.vue'
import KabaddiMatchMini from './components/kabaddi/MatchMini.vue'
import KabaddiMatchTeam from './components/kabaddi/MatchTeam.vue'
import KabaddiMatchTimeline from './components/kabaddi/MatchTimeline.vue'
import KabaddiMatchStats from './components/kabaddi/MatchStats.vue'

import CricketCoverage from './components/cricket/Coverage.vue'
import CricketSeasonMenu from './components/cricket/SeasonMenu.vue'
import CricketMatchMini from './components/cricket/MatchMini.vue'
import CricketMatchTeam from './components/cricket/MatchTeam.vue'
import CricketMatchScorecard from './components/cricket/MatchScorecard.vue'
import CricketMatchStats from './components/cricket/MatchStats.vue'
import CricketMatchInningsMenu from './components/cricket/MatchInningsMenu.vue'
import CricketMatchScorecardInnings from './components/cricket/MatchScorecardInnings.vue'
import CricketMatchScorecardPartnership from './components/cricket/MatchScorecardPartnership.vue'
import CricketMatchScorecardInningsBatLine from './components/cricket/MatchScorecardInningsBatLine.vue'
import CricketMatchScorecardInningsBowlLine from './components/cricket/MatchScorecardInningsBowlLine.vue'
import CricketMatchPlayer from './components/cricket/MatchPlayer.vue'
import CricketMatchBall from './components/cricket/MatchBall.vue'

import CricketFantasyCreateTeam from './components/cricket/fantasy/CreateTeam'
import CricketFantasyAddToTeamButton from './components/cricket/fantasy/AddToTeamButton'

import MainMenu from './components/MainMenu.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Menu from './components/fantasyconsole/Menu.vue'
import SubMenu from './components/workflow/SubMenu.vue'

Vue.config.productionTip = false
Vue.mixin(AppStateMixin)

Vue.component('LoadingState', LoadingState)
Vue.component('AppDailog', AppDailog)
Vue.component('AppHangDailog', AppHangDailog)
Vue.component('SvgIcon', SvgIcon)

Vue.component('FootballMatchMini', FootballMatchMini)
Vue.component('FootballMatchTimeline', FootballMatchTimeline)
Vue.component('FootballMatchTeam', FootballMatchTeam)
Vue.component('FootballMatchStats', FootballMatchStats)

Vue.component('KabaddiSeasonMenu', KabaddiSeasonMenu)
Vue.component('KabaddiMatchMini', KabaddiMatchMini)
Vue.component('KabaddiMatchTeam', KabaddiMatchTeam)
Vue.component('KabaddiMatchTimeline', KabaddiMatchTimeline)
Vue.component('KabaddiMatchStats', KabaddiMatchStats)

Vue.component('CricketCoverage', CricketCoverage)
Vue.component('CricketSeasonMenu', CricketSeasonMenu)
Vue.component('CricketMatchMini', CricketMatchMini)
Vue.component('CricketMatchTeam', CricketMatchTeam)
Vue.component('CricketMatchScorecard', CricketMatchScorecard)
Vue.component('CricketMatchStats', CricketMatchStats)
Vue.component('CricketMatchInningsMenu', CricketMatchInningsMenu)
Vue.component('CricketMatchScorecardInnings', CricketMatchScorecardInnings)
Vue.component('CricketMatchScorecardPartnership', CricketMatchScorecardPartnership)
Vue.component('CricketMatchScorecardInningsBatLine', CricketMatchScorecardInningsBatLine)
Vue.component('CricketMatchScorecardInningsBowlLine', CricketMatchScorecardInningsBowlLine)
Vue.component('CricketMatchPlayer', CricketMatchPlayer)
Vue.component('CricketMatchBall', CricketMatchBall)
Vue.component('FantasyCreateTeam', CricketFantasyCreateTeam)
Vue.component('FantasyAddToTeamButton', CricketFantasyAddToTeamButton)

Vue.component('MainMenu', MainMenu)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('SubMenu', SubMenu)
Vue.component('Menu', Menu)

Vue.use(Element, { locale })

Vue.prototype.$globalEvents = new Vue()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
